// extracted by mini-css-extract-plugin
export default {"container":"ContentThumbnailAndName_container__m3cNi","thumbnail":"ContentThumbnailAndName_thumbnail__lQPTc","small":"ContentThumbnailAndName_small__bUZZb"};